/** Retire l'écran de démarrage du HTML (affiché sur « / » avant le chargement de l'application). */
export function hideBoot(delay = 0): void {
  window.setTimeout(() => {
    const el = document.getElementById('boot');
    if (!el) return;
    el.classList.add('boot-out');
    window.setTimeout(() => el.remove(), 400);
  }, delay);
}
